import 'regenerator-runtime/runtime'; // required by service-worker.js
function getAbsolutePath() {
    let publicPathFromEnv = process.env.PUBLIC_PATH;
    if (!publicPathFromEnv) {
        return '/';
    }
    if (!publicPathFromEnv.startsWith('/')) {
        publicPathFromEnv = `/${publicPathFromEnv}`;
    }
    if (!publicPathFromEnv.endsWith('/')) {
        publicPathFromEnv = `${publicPathFromEnv}/`;
    }
    return publicPathFromEnv;
}
// Adapted from https://web.dev/offline-fallback-page/
export function registerServiceWorker() {
    window.addEventListener('load', () => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register(`${getAbsolutePath()}service-worker.js`);
            console.log('serviceWorker registered');
        }
    });
}
